import React, { useState } from 'react'
import '../../../Assets/Css/ViewAppreciation.scss'
import { connect } from 'react-redux'
import Medal from '../../../Assets/Images/Employee/Medal-G.svg';
import ProfilePic from '../../../Assets/Images/Employee/testimonial-3.jpg';
import { useLocation, useNavigate } from 'react-router-dom';
import UserAvatar from 'react-user-avatar';
import { getIconComponent } from '../../../Lib/utils';

const ViewAppreciation = (props) => {

    const location = useLocation();
    const navigate = useNavigate();
    const data = location?.state?.data?.allData;
    const Icon = getIconComponent(data?.award?.icon);
    return (
        <div className="viewAppreciation-main">
            <div className="page-title">
                <h4> Appreciation </h4>
                <div className="edit-btn">
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >Cancel</button>
                </div>
            </div>
            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className="appreciation-detail">
                                    <h5 className='appreciation-detail-divider'> Appreciation Details </h5>
                                    <div className="row">
                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Award</h6>
                                            </div>
                                            <div className="col-9">
                                                <div className="appreciation-detail-icon">
                                                    <div className="trophy-icon"
                                                        style={{
                                                            backgroundColor: data?.award?.icon_background_color || '#eee',
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            color: '#fff',
                                                            fontSize: 20,
                                                        }}>
                                                        <Icon />
                                                    </div>
                                                    <h6 className='labels'>{data?.award?.title}</h6>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Award Date</h6>
                                            </div>
                                            <div className="col-9">
                                                <h6 className='labels'>{data?.date?.split(" ")[0]}</h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Summary</h6>
                                            </div>
                                            <div className="col-9">
                                                <h6 className='labels' dangerouslySetInnerHTML={{ __html: data?.summary }}></h6>
                                            </div>
                                        </div>

                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Given To</h6>
                                            </div>
                                            <div className="col-9">
                                                <div className="profile-section">
                                                    {data?.user?.profile_pic ? (
                                                        <img src={`data:image/jpeg;base64,${btoa(
                                                            new Uint8Array(data?.user?.profile_pic?.data).reduce(
                                                                (data, byte) => data + String.fromCharCode(byte),
                                                                ''
                                                            )
                                                        )}`} alt="Profile Pic" className="profile-pic" />
                                                    ) : (
                                                        <UserAvatar name={data?.user?.name} className="profile-pic" size={45} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                                                    )}
                                                    <div className="profile-info">
                                                        <h6 className='labels'>{data?.user?.name}</h6>
                                                        <h6 className='labels'>{data?.user?.designation?.name}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewAppreciation;